export default __webpack_public_path__ + "static/media/(50).5a04558d.jpg";